export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 128

/** Uppercase, lowercase, number, and a character that is not a letter or number. */
export const PASSWORD_STRENGTH_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/

export function isStrongPassword(value) {
  if (typeof value !== "string") return false
  if (
    value.length < PASSWORD_MIN_LENGTH ||
    value.length > PASSWORD_MAX_LENGTH
  ) {
    return false
  }
  return PASSWORD_STRENGTH_PATTERN.test(value)
}
